export const clearObject = (obj) =>
  Object.keys(obj).reduce((newObj, key) => {
    newObj[key] = {}
    return newObj
  }, {})
